/// <reference path="koyori.ts" />
/// <reference path="button.ts" />

/**
 * クリックされた際に他のエレメントのアトリビュートを切り替えるボタンコンポーネントです。
 * <dl>
 * <dt>属性</dt>
 * <dd>target: 対象エレメントのセレクタ</dd>
 * <dd>attr: 対象アトリビュート</dd>
 * <dd>value: 対象アトリビュートに設定する値</dd>
 * <dd>toggle: 対象アトリビュートに値がすでに設定されている場合に削除する場合に設定する<//dd>
 * </dl>
 */
class KoyoriAttrButton extends KoyoriButton {

	constructor() {
		super();

		this.addEventListener('click', () => {
			let element = document.querySelector(this.getAttribute('target'));
			let attr = this.getAttribute('attr');
			let value = this.getAttribute('value');
			let current = element.getAttribute(attr);
			if (current == null || current != value) {
				element.setAttribute(attr, value);
			} else if (this.getAttribute('toggle') != null) {
				element.removeAttribute(attr);
			}
		});
	}

}
window.customElements.define('koy-attr-button', KoyoriAttrButton);